/**
 * Takes in an office name (in the format of an account name in salesforce) and returns a shorter version.
 *
 * @param value {string}: Full name of office (e.g. "V3 El Dorado Hills").
 * @return {string}: Shortened office name.
 */
const shortenOfficeName = (value) => {
    let newString = value.replace("V3 ", "");

    if (newString.includes(" ")){
        let firstName = newString.split(" ");
        if (firstName[0] === "North" || firstName[0] === "Granite") {
            return newString;
        }
        if (firstName.length === 2 && firstName[0] !== "San"){
            return firstName[0];
        } else{
            let initials = "";
            for (let i = 0;  i < firstName.length; i++){
                initials += firstName[i].charAt(0);
            }
            return initials;
        }
    }

    return newString;
};

export default shortenOfficeName;
